import { render, staticRenderFns } from "./boxdata.vue?vue&type=template&id=ac8982dc&scoped=true&"
import script from "./boxdata.vue?vue&type=script&lang=js&"
export * from "./boxdata.vue?vue&type=script&lang=js&"
import style0 from "./boxdata.vue?vue&type=style&index=0&id=ac8982dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8982dc",
  null
  
)

export default component.exports